import React, { useEffect, useState } from "react";
import './BaleDetails.css';
import { FaArrowRightLong } from "react-icons/fa6";
import { GrView } from "react-icons/gr";
import { useDispatch, useSelector } from "react-redux";
import { fetchLumpBarcode } from "../../Store/PHPSlice/Cutting/clothIssue";
import { selectLumpBarcode, selectRack, selectTempBaleLump } from "../Selectors/Master/ItemSelectors";
import { TbEdit } from "react-icons/tb";
import LumpMtrTbl from "./LumpMtrTbl";
import { fetchRackData } from "../../Store/PHPSlice/Rack";
import { useParams } from "react-router-dom";
import { fetchTempBaleLump, insertTempBaleLump } from "../../Store/PHPSlice/Purchase/PoNo";

const BaleLump = () => {
    const { Id } = useParams();
    const [rows, setRows] = useState([]);
    const [formData, setFormData] = useState({
        Id: '',
        clothId: '',
        userId: '1'
    });
    const [lumpRows, setLumpRows] = useState([]);
    const [lumpTotMtr, setLumpTotMtr] = useState(0);
    const [lumpId, setLumpId] = useState(null);
    const [baleLump, setBaleLump] = useState('');
    const [totalMtr, setTotalMtr] = useState(0);
    const [barcodeLump, setBarcodeLump] = useState(null);
    const [openEdit, setOpenEdit] = useState(false);
    const [openLumpDetails, setLumpDetails] = useState(false);
    const dispatch = useDispatch();
    const lumpbar = useSelector(selectLumpBarcode);
    const racklist = useSelector(selectRack);

    const prevTempBalelist = useSelector(selectTempBaleLump);

    useEffect(() => {
        dispatch(fetchLumpBarcode());
        dispatch(fetchRackData());
    }, []);

    useEffect(() => {
        const splitID = Id.split('-');
        const id = splitID[0];
        const clothId = splitID[1];
        setFormData(prev => ({
            ...prev,
            clothId: clothId,
            Id: id
        }));
        dispatch(fetchTempBaleLump(clothId));
    }, [Id]);

    useEffect(() => {
        if (prevTempBalelist?.data?.length > 0) {
            const rowdata = prevTempBalelist.data.map(entry => ({
                ...entry, // Spread the original properties
                selected: false, // Add the new property
                lumpRows: entry?.lumpRows?.map(val => ({
                    ...val, // Spread the original properties of each lumpRow
                    selected: false, // Add the new property to lumpRow
                })) || [] // Default to an empty array if lumpRows is undefined or null
            }));


            const updateTotalBalemtr = rowdata.reduce((sum, entry) => sum + (parseFloat(entry.mtrKg) || 0), 0);
            setRows(rowdata);
            setTotalMtr(updateTotalBalemtr);
        }
    }, [prevTempBalelist]);



    useEffect(() => {
        if (lumpbar?.data?.Lumpbar) {
            const data = {
                old: lumpbar?.data?.Lumpbar,
                new: lumpbar?.data?.Lumpbar
            };
            setBarcodeLump(data);
        }
    }, [lumpbar]);

    const handleInputChange = (index, field, value) => {
        let newRows = [...rows];
        newRows[index][field] = value;

        // Update total if the field is "mtrKg"
        if (field === "mtrKg") {
            const total = newRows.reduce((sum, row) => sum + parseFloat(row.mtrKg || 0), 0);
            setTotalMtr(total.toFixed(2));
        }
        // Handle "lump" field change
        // if (field === "lump") {
        //     const lumpCount = parseInt(value, 10) || 0; // Ensure value is an integer
        //     const barcode = lumpbar?.data?.Lumpbar;
        //     const no_bar = barcode?.split('-');

        //     const updatedLumpRows = Array.from({ length: lumpCount }, (_, idx) => (
        //         {
        //             barcode: no_bar ? `${no_bar[0]} - ${parseFloat(no_bar[1]) + idx}` : "", // If barcode exists, append the index for uniqueness
        //             mtr: "" // Initialize the mtr as empty
        //         }));

        //     newRows[index].lumpRows = updatedLumpRows;
        // }
        setRows(newRows);
    };

    // const handleAddlump = (index) => {
    //     const newRow = [...rows];
    //     const barcode = lumpbar?.data?.Lumpbar;
    //     const no_bar = barcode?.split('-');
    //     // Check if lumpRows already exists, if not, initialize it as an empty array
    //     if (!newRow[index].lumpRows) {
    //         newRow[index].lumpRows = [];

    //         var bar = `${no_bar[0]} - ${parseFloat(no_bar[1])}`
    //     } else {
    //         // If lumpRows exists, find the last barcode in the array and increment it
    //         const lastBarcode = newRow[index].lumpRows[newRow[index].lumpRows.length - 1].barcode;
    //         const lastNoBar = lastBarcode?.split(' - ');
    //         const incrementedValue = parseFloat(lastNoBar[1]) + 1;

    //         var bar = `${lastNoBar[0]} - ${incrementedValue}`;
    //     }

    //     const newLump = {
    //         barcode: bar,
    //         mtr: ''
    //     };

    //     // Add the newLump object to the lumpRows array at the specified index
    //     newRow[index].lumpRows.push(newLump);
    //     setRows(newRow);
    // };

    // const handleAddlump = (index, bale) => {
    //     setLumpId(index);
    //     if (lumpId !== index) {
    //         const barcode = lumpbar?.data?.Lumpbar;
    //         const no_bar = barcode?.split('-');
    //         var bar = `${no_bar[0]}-${parseFloat(no_bar[1])}`
    //         const newLump = {
    //             barcode: bar,
    //             mtr: ''
    //         };
    //         setLumpRows([newLump]);
    //         setBaleLump(bale);
    //     } else {
    //         const barcode = lumpbar?.data?.Lumpbar;
    //         const no_bar = barcode?.split('-');
    //         // Check if lumpRows already exists, if not, initialize it as an empty array
    //         if (lumpRows.length == 0) {
    //             var bar = `${no_bar[0]}-${parseFloat(no_bar[1])}`
    //         } else {
    //             // If lumpRows exists, find the last barcode in the array and increment it
    //             const lastBarcode = lumpRows[lumpRows.length - 1].barcode;
    //             const lastNoBar = lastBarcode?.split('-');
    //             const incrementedValue = parseFloat(lastNoBar[1]) + 1;

    //             var bar = `${lastNoBar[0]}-${incrementedValue}`;
    //         }
    //         const newLump = {
    //             barcode: bar,
    //             mtr: ''
    //         };
    //         setLumpRows([...lumpRows, newLump]);
    //         setBaleLump(bale);
    //     }
    // };

    // const handleAddlump = (index, bale) => {
    //     setLumpDetails(true);
    //     setLumpId(index);
    //     setBaleLump(bale);
    //     if (rows[index]?.lumpRows?.length > 0) {
    //         setOpenEdit(!openEdit);
    //         const lumprows = rows[lumpId].lumpRows;
    //         const updateLumps = [...lumprows];
    //         const no_bar = barcodeLump?.new.split('-');
    //         var bar = `${no_bar[0]}-${parseFloat(no_bar[1])}`;
    //         // console.log(bar);
    //         const updateBarcode = `${no_bar[0]}-${parseFloat(no_bar[1]) + 1}`;
    //         const newLump = {
    //             barcode: bar,
    //             mtr: '',
    //             selected: false,
    //         };
    //         setLumpRows(updateLumps);
    //         setBaleLump(rows[lumpId].bale);
    //         setLumpTotMtr(rows[lumpId].mtrKg);
    //     }
    // };

    // 30-12-2024

    const handleAddlump = (index, bale) => {
        // Set necessary states
        setLumpDetails(true);
        setLumpId(index); // Update lumpId state
        setBaleLump(bale); // Update baleLump state

        // Access rows directly using the index passed to the function
        const row = rows[index];

        if (row?.lumpRows?.length > 0) {
            setOpenEdit((prevState) => !prevState); // Use functional update for toggling state
            const lumprows = row.lumpRows; // Directly access lumpRows from the current index
            const updateLumps = [...lumprows];

            const no_bar = barcodeLump?.new.split('-');
            var bar = `${no_bar[0]}-${parseFloat(no_bar[1])}`;
            const updateBarcode = `${no_bar[0]}-${parseFloat(no_bar[1]) + 1}`;

            const newLump = {
                barcode: bar,
                mtr: '',
                color: '',
                selected: false,
            };

            // Update other states
            setLumpRows(updateLumps);
            setBaleLump(row.bale);
            setLumpTotMtr(row.mtrKg);
        }
    };

    const handlePerticularLumpAdd = () => {
        if (rows[lumpId]?.lumpRows?.length > 0) {
            // console.log('Hii');
            const lumprows = rows[lumpId].lumpRows;
            const updateLumps = [...lumprows];
            const no_bar = barcodeLump?.new.split('-');
            var bar = `${no_bar[0]}-${parseFloat(no_bar[1])}`;
            // console.log(bar);
            const updateBarcode = `${no_bar[0]}-${parseFloat(no_bar[1]) + 1}`;
            const newLump = {
                barcode: bar,
                mtr: '',
                color: '',
                selected: false,
            };
            updateLumps.push(newLump);
            setBaleLump(rows[lumpId].bale);
            setLumpTotMtr(rows[lumpId].mtrKg);
            setLumpRows(updateLumps);
            setBarcodeLump(prev => ({
                ...prev,
                new: updateBarcode
            }));
        } else if (lumpId !== lumpId) {
            const no_bar = barcodeLump?.old.split('-');
            var bar = `${no_bar[0]}-${parseFloat(no_bar[1])}`;
            const updateBarcode = `${no_bar[0]}-${parseFloat(no_bar[1]) + 1}`;
            const newLump = {
                barcode: bar,
                mtr: '',
                color: '',
                selected: false,
            };
            setLumpRows([newLump]);
            setBarcodeLump(prev => ({
                ...prev,
                new: updateBarcode
            }));
        } else {
            const no_bar = barcodeLump?.new.split('-');
            var bar = `${no_bar[0]}-${parseFloat(no_bar[1])}`;
            const updateBarcode = `${no_bar[0]}-${parseFloat(no_bar[1]) + 1}`;
            const newLump = {
                barcode: bar,
                mtr: '',
                color: '',
                selected: false,
            };
            setLumpRows([...lumpRows, newLump]);
            setBarcodeLump(prev => ({
                ...prev,
                new: updateBarcode
            }));
        }
    }

    const handleAddRow = () => {
        const newRow = {
            id: rows.length + 1,
            bale: "",
            mtrKg: "",
            rack: "",
            lump: "",
            selected: false,
        };
        setRows([...rows, newRow]);
    };

    const handleLumpAddBale = () => {
        const newRow = [...rows];
        newRow[lumpId].lumpRows = lumpRows;
        newRow[lumpId].mtrKg = lumpTotMtr;
        const updatebar = barcodeLump?.new;

        // const updateTotalBalemtr = lumpTotMtr + totalMtr;
        const updateTotalBalemtr = newRow.reduce((sum, entry) => sum + (parseFloat(entry.mtrKg) || 0), 0);
        setRows(newRow);
        setLumpRows([]);
        setLumpTotMtr(0);

        setBarcodeLump(prev => ({
            ...prev,
            old: updatebar
        }));
        setBaleLump('');
        setTotalMtr(updateTotalBalemtr);
        setLumpDetails(false);
    };

    const handleDeleteRows = () => {
        const filteredRows = rows.filter((row) => !row.selected);
        setRows(filteredRows);
    };

    const handleRowSelection = (index) => {
        const newRows = [...rows];
        newRows[index].selected = !newRows[index].selected;
        const currmtr = newRows[index].mtrKg;
        let totmtr = newRows.reduce((acc, mtr) => acc + parseFloat(mtr.mtrKg), 0);
        let finaltot = totmtr - parseFloat(currmtr);
        setTotalMtr(finaltot);
        setRows(newRows);
    };
    const handleDeleteLumps = () => {
        const filteredRows = lumpRows.filter((row) => !row.selected);
        setLumpRows(filteredRows);
        // const no_bar = barcodeLump?.new.split('-');
        // const updateBarcode = `${no_bar[0]}-${parseFloat(no_bar[1]) - 1}`;
        // setBarcodeLump(prev => ({
        //     ...prev,
        //     new: updateBarcode
        // }));
        const totmtr = filteredRows.reduce((acc, mtr) => acc + parseFloat(mtr.mtr), 0);
        setLumpTotMtr(totmtr);

    };

    const handleLumpSelection = (index) => {
        const newRows = [...lumpRows];
        newRows[index].selected = !newRows[index].selected;
        setLumpRows(newRows);
    };

    // Function to handle the change of Bale Mtr value
    const handleLumpMtr = (index, value) => {
        const updateLumps = [...lumpRows];
        updateLumps[index].mtr = value;
        // Calculate the sum of all mtr values in the lumpRows array
        const totalMtr = updateLumps.reduce((sum, lump) => {
            // Ensure that mtr values are numeric and handle potential empty values
            const mtrValue = parseFloat(lump.mtr) || 0;
            return sum + mtrValue;
        }, 0);

        setLumpTotMtr(totalMtr);
        setLumpRows(updateLumps);
    };

    const handleLumpColor = (index, value) => {
        const updateLumps = [...lumpRows];
        updateLumps[index].color = value;
    
        setLumpRows(updateLumps);
    };

    const handleClose = () => {
        setLumpDetails(false);
    };

    function postobj(rows, formData) {
        const data = {
            indx: formData.Id,
            clothId: formData.clothId,
            baleLump: rows,
            userId: formData.userId
        };
        return data;
    }
    const handleSubmit = () => {
        const postdata = postobj(rows, formData);
        // console.log("Final Data:", postdata);
        const resend = {
            index: parseFloat(formData.Id) - 1,
            totmtr: totalMtr
        };
        if (window.opener && window.opener.handleResendFromChild) {
            window.opener.handleResendFromChild(resend);
        }

        dispatch(insertTempBaleLump(postdata))
            .unwrap()
            .then((result) => {
                // Handle success
                // console.log('POST request successful!', result);
                window.close();
                // You may want to update your component state or perform any other action
            })
            .catch((error) => {
                // Handle error
                console.error('Error while making POST request:', error);
                // You may want to display an error message to the user or perform any other action
            });

    };

    return (
        <div className="bale-details-container">
            <h3>Bale Details <FaArrowRightLong className="right-arrow" /></h3>
            <div className="button-group">
                <button className="add" onClick={handleAddRow}>Add</button>
                <button className="delete" onClick={handleDeleteRows}>Delete</button>
            </div>
            <div className="total-meter">
                Total Mtr: <span>{totalMtr}</span>
            </div>
            <table>
                <thead>
                    <tr>
                        <th>Sr. No.</th>
                        <th>Bale</th>
                        {/* <th>Bale Mtr/KG</th> */}
                        <th>Bale Mtr</th>
                        <th>Rack</th>
                        <th>Lump</th>
                    </tr>
                </thead>
                <tbody>
                    {rows?.map((row, index) => (
                        <tr key={index}>
                            <td>
                                <input
                                    type="checkbox"
                                    checked={row.selected}
                                    onChange={() => handleRowSelection(index)}
                                />{" "}
                                {row.id}
                            </td>
                            <td>
                                <input
                                    type="text"
                                    placeholder="Enter Bale No"
                                    value={row.bale}
                                    onChange={(e) => handleInputChange(index, "bale", e.target.value)}
                                />
                            </td>
                            <td>
                                <input
                                    type="text"
                                    placeholder="Bale Mtr"
                                    value={row.mtrKg}
                                    onChange={(e) => handleInputChange(index, "mtrKg", e.target.value)}
                                />
                            </td>
                            <td>
                                <select
                                    value={row.rack}
                                    onChange={(e) => handleInputChange(index, "rack", e.target.value)}
                                >
                                    <option value="">Select</option>
                                    {/* <option value="Rack 1">Rack 1</option>
                                    <option value="Rack 2">Rack 2</option>
                                    <option value="Rack 3">Rack 3</option> */}
                                    {
                                        racklist?.data?.map((rack, index) => (
                                            <option value={rack.rackNm} key={index}>{rack.rackNm}</option>
                                        ))
                                    }
                                </select>


                            </td>
                            <td>
                                {
                                    row?.lumpRows?.length > 0 ?
                                        <>
                                            {/* <TbEdit className="TbEdit" onClick={() => handleEditLump(index, row.lumpRows)} /> */}

                                            <button type="button" className="lump-btn" onClick={() => handleAddlump(index, row.bale)}>Add Lump</button>
                                        </>
                                        :

                                        <button type="button" className="lump-btn" onClick={() => handleAddlump(index, row.bale)}>Add Lump</button>
                                }

                                {/* <input
                                    type="text"
                                    placeholder="Bale Mtr"
                                    value={row.lump}
                                    onChange={(e) => handleInputChange(index, "lump", e.target.value)}
                                /> */}
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>

            {/* {
                openEdit === true ?
                    (
                        <div className="lump-content">
                            <h3>Lump Details <FaArrowRightLong className="right-arrow" /> {rows[lumpId]?.bale}</h3>
                            <div className="button-group">
                                <button className="add" onClick={handleLumpAddBale}>Add</button>
                                <button className="delete" onClick={handleDeleteRows}>Remove</button>
                            </div>
                            <table style={{ width: '30%' }}>
                                <thead>
                                    <tr>
                                        <th>Sr. No.</th>
                                        <th>Barcode</th>
                                        <th>Lump Mtr</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {rows[lumpId]?.lumpRows?.map((lumpRow, lumpIndex) => (
                                        <>
                                            <tr key={lumpIndex}>
                                                <td>
                                                    {lumpIndex + 1}
                                                </td>
                                                <td>
                                                    <input
                                                        type="text"
                                                        placeholder="Enter Bale No"
                                                        value={lumpRow.barcode}
                                                        readOnly
                                                    />
                                                </td>
                                                <td>
                                                    <input
                                                        type="text"
                                                        placeholder="Bale Mtr"
                                                        value={lumpRow.mtr}
                                                        onChange={(e) => handleLumpMtr(
                                                            lumpIndex,
                                                            e.target.value
                                                        )}
                                                    />
                                                </td>

                                            </tr>
                                        </>
                                    ))}
                                    <tr>
                                        <td> </td>
                                        <td>
                                            <span className="tot-lump">Total Lump Mtr</span>
                                        </td>
                                        <td>
                                            <span className="tot-lump">{rows[lumpId]?.mtrKg}</span>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>

                        </div>
                    ) : null
            } */}
            {/* <div className="lump-content">
                <h3>Lump Details <FaArrowRightLong className="right-arrow" /> {baleLump}</h3>
                <div className="button-group">
                    <button className="add" onClick={handleLumpAddBale}>Add</button>
                    <button className="delete" onClick={handleDeleteRows}>Remove</button>
                </div>
                <table style={{ width: '30%' }}>
                    <thead>
                        <tr>
                            <th>Sr. No.</th>
                            <th>Barcode</th>
                            <th>Lump Mtr</th>
                        </tr>
                    </thead>
                    <tbody>
                        {lumpRows?.map((lumpRow, lumpIndex) => (
                            <>
                                <tr key={lumpIndex}>
                                    <td>
                                        {lumpIndex + 1}
                                    </td>
                                    <td>
                                        <input
                                            type="text"
                                            placeholder="barcode"
                                            value={lumpRow.barcode}
                                            readOnly
                                        />
                                    </td>
                                    <td>
                                        <input
                                            type="text"
                                            placeholder="Lump Mtr"
                                            value={lumpRow.mtr}
                                            onChange={(e) => handleLumpMtr(
                                                lumpIndex,
                                                e.target.value
                                            )}
                                        />
                                    </td>

                                </tr>
                            </>
                        ))}
                        <tr>
                            <td> </td>
                            <td>
                                <span className="tot-lump">Total Lump Mtr</span>
                            </td>
                            <td>
                                <span className="tot-lump">{lumpTotMtr}</span>
                            </td>
                        </tr>
                    </tbody>
                </table>

            </div> */}



            {openLumpDetails === true &&
                <div>
                    <hr />
                    {
                        openEdit === true ? (
                            <LumpMtrTbl
                                baleLump={rows[lumpId]?.bale}
                                handleDeleteRows={handleDeleteLumps}
                                handleLumpAddBale={handleLumpAddBale}
                                lumpRows={lumpRows}
                                lumpTotMtr={lumpTotMtr}
                                handleLumpMtr={handleLumpMtr}
                                handleLumpSelection={handleLumpSelection}
                                handlePerticularLumpAdd={handlePerticularLumpAdd}
                                handleClose={handleClose}
                                handleLumpColor={handleLumpColor}
                            />
                        ) : (

                            <LumpMtrTbl
                                baleLump={baleLump}
                                handleDeleteRows={handleDeleteLumps}
                                handleLumpAddBale={handleLumpAddBale}
                                lumpRows={lumpRows}
                                lumpTotMtr={lumpTotMtr}
                                handleLumpMtr={handleLumpMtr}
                                handleLumpSelection={handleLumpSelection}
                                handlePerticularLumpAdd={handlePerticularLumpAdd}
                                handleClose={handleClose}
                                handleLumpColor={handleLumpColor}
                            />
                        )
                    }
                    <hr />
                </div>}

            {/* <LumpMtrTbl
                baleLump={baleLump}
                handleDeleteRows={handleDeleteRows}
                handleLumpAddBale={handleLumpAddBale}
                lumpRows={lumpRows}
                lumpTotMtr={lumpTotMtr}
                handleLumpMtr={handleLumpMtr}
            /> */}

            <button className="submit" onClick={handleSubmit}>Submit</button>
        </div >
    );
};

export default BaleLump;
